<template>
  <footer class="footer">
    <div class="footer__primary">
      <div class="container">
        <div class="footer-main">
          <div
            class="footer-main__group footer-main__group_navs pb-sm-32 pb-md-0"
          >
            <div
              class="footer-main__navs"
              :class="{ _active: toggle.indexOf(idx) >= 0 }"
              v-for="(item, idx) in footerLinks"
              :key="idx"
            >
              <div @click="menuToggle(idx)" class="footer-main__group-title">
                <h3 class="font-r mb-0">{{ item.title }}</h3>
                <span
                  class="d-sm-none vrt-toggle-arrow"
                  :class="{ _flip: toggle.indexOf(idx) >= 0 }"
                >
                  <span></span>
                  <span></span>
                </span>
              </div>
              <nav
                class="footer-nav"
                :class="{ _open: toggle.indexOf(idx) >= 0 }"
              >
                <T1FooterLinks :links="item.items" />
              </nav>
            </div>
          </div>

          <div class="footer-main__group footer-main__group_contacts">
            <div class="footer-main__contacts">
              <div class="footer-main__group-title">
                <h3 class="font-r mb-0">Kontakt z obsługą</h3>
              </div>
              <div class="footer-contact">
                <div class="footer-contact__phone mb-8">
                  <span class="svg-icon mr-12" aria-hidden="true">
                    <svg
                      class="svg-icon__svg c-blue-light"
                      width="20"
                      height="20"
                      focusable="false"
                    >
                      <use
                        xlink:href="/img/static/svg-sprites.svg#icon-phone"
                      ></use>
                    </svg>
                  </span>
                  <a
                    class="font-r"
                    href="tel:+48717717621"
                    title="Zadzwoń: + 48 71 771 76 21"
                    >71 771 76 21</a
                  >
                </div>
                <div class="footer-contact__email mb-18">
                  <span class="svg-icon mr-12" aria-hidden="true">
                    <svg
                      class="svg-icon__svg c-blue-light"
                      width="20"
                      height="20"
                      focusable="false"
                    >
                      <use
                        xlink:href="/img/static/svg-sprites.svg#icon-at"
                      ></use>
                    </svg>
                  </span>
                  <a
                    href="mailto:rezerwacje@travelone.pl"
                    title="rezerwacje@travelone.pl"
                    >rezerwacje@travelone.pl</a
                  >
                </div>
                <div class="mb-12 font-14">
                  <div class="mr-12 mb-md-2">Obsługa telefoniczna:</div>
                  <div class="d-flex">
                    poniedziałek - sobota:
                    <span class="ml-8 ml-auto">9:00 - 22:00</span>
                  </div>
                  <div class="d-flex">
                    niedziela:
                    <span class="ml-8 ml-auto">10:00 - 21:00</span>
                  </div>
                </div>
                <div class="mt-md-12 font-14">
                  <div class="mr-12 mb-md-2">
                    Obsługa zamówień internetowych:
                  </div>
                  <div class="d-flex">
                    poniedziałek - piątek:
                    <span class="ml-8 ml-auto">8:00 - 22:00</span>
                  </div>
                  <div class="d-flex">
                    sobota - niedziela:
                    <span class="ml-8 ml-auto">9:00 - 22:00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer__secondary">
      <div class="container">
        <T1FooterTourops />
        <T1FooterAddons />
      </div>
    </div>

    <div class="footer-end">
      <div class="container">
        <div class="gray-60 pt-24 pb-24">
          <p class="mb-0">
            Informacje lub ceny opublikowane na stronach TravelOne.pl nie
            stanowią oferty w rozumieniu przepisów kodeksu cywilnego.
            <br />
            &copy; {{ getCurrentYear() }} TravelOne.pl. Korzystanie z serwisu
            oznacza akceptację
            <a
              href="https://www.travelone.pl/warunki/regulamin_korzystania_z_serwisu_t1.pdf"
              rel="nofollow noopener"
              target="_blank"
              title="Regulamin serwisu TravelOne.pl"
              >regulaminu</a
            >.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { footerLinks } from "./footerLinks";
import T1FooterLinks from "./T1FooterLinks";
import T1FooterTourops from "./T1FooterTourops";
import T1FooterAddons from "./T1FooterAddons";

export default {
  name: "page-footer",
  components: {
    T1FooterLinks,
    T1FooterTourops,
    T1FooterAddons,
  },
  data: () => ({
    footerLinks: footerLinks.groups,
    toggle: [],
  }),
  methods: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
    menuToggle(key) {
      let i = this.toggle.indexOf(key);
      if (i < 0) {
        this.toggle.push(key);
      } else {
        this.toggle.splice(i, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  &__primary {
    background-color: darken($blue-dark, 5%);
    color: #fff;
    padding: 24px 0 32px;

    @media (min-width: $screen-sm) {
      padding: 36px 0;
    }

    @media (min-width: $screen-md) {
      padding: 46px 0 40px;
    }
  }
}

.footer-main {
  @include font-l();

  @media (min-width: $screen-sm) {
    margin-left: -16px;
    margin-right: -16px;
  }

  @media (min-width: $screen-md) {
    display: flex;
  }

  &__group {
    @media (max-width: $screen-xs-max) {
      margin-left: -16px;
      margin-right: -16px;
    }
  }

  &__group-title {
    @media (max-width: $screen-xs-max) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
    }

    @media (min-width: $screen-sm) {
      margin-bottom: 16px;
      pointer-events: none;
    }
  }

  &__group_navs {
    @media (min-width: $screen-sm) {
      display: flex;
      width: 100%;
    }

    @media (min-width: $screen-md) {
      width: 72%;
    }
  }

  &__navs {
    @media (max-width: $screen-xs-max) {
      padding-left: 16px;
      padding-right: 16px;

      &._active {
        animation: backgroundPulse 0.5s;
      }
    }

    @media (min-width: $screen-sm) {
      padding: 0 16px;
      flex: 0 0 percentage(1/3);
    }
  }

  &__group_contacts {
    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: $screen-sm) {
      width: 100%;
    }

    @media (min-width: $screen-md) {
      width: 28%;
    }
  }
}

.footer-nav {
  @media (max-width: $screen-xs-max) {
    max-height: 0;
    overflow: hidden;
    transition: all 0.35s ease-in-out;

    &._open {
      max-height: 240px;
      padding-top: 12px;
    }
  }
}

.footer-contact {
  @media (max-width: $screen-sm-max) {
    max-width: 320px;
  }

  @media (max-width: $screen-xs-max) {
    padding-top: 6px;
  }

  &__phone,
  &__email {
    > a {
      color: lighten($blue-light, 40%);
      text-decoration: none;

      &:hover {
        color: $blue-light;
      }
    }
  }

  &__phone {
    display: flex;
    align-items: center;
    font-size: 26px;
  }
}

.footer-end {
  background-color: $gray-00;
  font-size: 12px;

  @media (min-width: $screen-md) {
    font-size: 14px;
  }
}

.vrt-toggle-arrow {
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 12.5px;
  height: 100%;

  > span {
    background-color: #fff;
    border-radius: 1px;
    display: flex;
    align-items: center;
    position: absolute;
    width: 8px;
    height: 2px;
    transition: all 0.05s linear;

    &:first-of-type {
      left: 0;
      transform: rotate(45deg);
    }

    &:last-of-type {
      right: 0;
      transform: rotate(-45deg);
    }
  }

  &._flip {
    > span:first-of-type {
      transform: rotate(-45deg);
    }

    > span:last-of-type {
      transform: rotate(45deg);
    }
  }
}

@keyframes backgroundPulse {
  0% {
    background-color: darken($blue-dark, 10%);
  }
  100% {
    background-color: transparent;
  }
}

</style>
